import { render } from "./BIBOHistory.vue?vue&type=template&id=88ae9f10"
import script from "./BIBOHistory.vue?vue&type=script&lang=ts"
export * from "./BIBOHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script